import * as React from "react";
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { RouteProps } from "./routes-path";

import pathClenove from "./clenove/routes-path";
import Clenove from "./clenove/Clenove";

import pathPary from "./pary/routes-path";
import Pary from "./pary/Pary";

import pathKluby from "./kluby/routes-path";
import Kluby from "./kluby/Kluby";

class Evidence extends React.PureComponent<RouteComponentProps<RouteProps>, {}> {

    render() {
        const pathRedirect = "/";

        return <Switch>
            <Route path={pathClenove} render={(routeProps) => <Clenove />} />
            <Route path={pathKluby} render={(routeProps) => <Kluby />} />
            <Route path={pathPary} render={(routeProps) => <Pary />} />

            <Redirect to={pathRedirect} />
        </Switch>;
    }
}

export default withRouter(Evidence);